import { MenuType } from './menu';
import { Permissions } from './permissions';

export type VirtualPortalNode = VirtualPortalSection | VirtualPortalFolder | VirtualPortalNote | VirtualPortalPage;

export interface VirtualNodeBase {
  type: PortalNodeType;
  title: string;
  path: string;
  id: string;
  visible: boolean;
  permissions?: Permissions;
}

export enum PortalNodeType {
  PAGE = 'portalPage',
  SECTION = 'portalSection',
  FOLDER = 'folder',
  NOTE = 'note',
}

export interface VirtualPortalSection extends VirtualNodeBase {
  type: PortalNodeType.SECTION;
}

export interface VirtualPortalFolder extends VirtualNodeBase {
  type: PortalNodeType.FOLDER;
}

export interface VirtualPortalNote extends VirtualNodeBase {
  type: PortalNodeType.NOTE;
  noteId: string;
  share: string;
}

export interface VirtualPortalPage extends VirtualNodeBase {
  type: PortalNodeType.PAGE;
}

export interface GenerateSectionParams {
  title: string;
  menuType: MenuType;
  parentId?: string;
  visible?: boolean;
}

export interface GeneratePageParams {
  title?: string;
  menuType: MenuType;
  parentId?: string;
  visible?: boolean;
}
